import { settingsToQueryString } from './video-utils';
import { apiEndpoints } from 'apiService';
import { seasonSettingsToQueryString } from './season-utils';
import { httpClient } from 'ajax';

export function getVideos(settings, siteId, showLoading = () => {}) {
    showLoading();
    let data;
    const componentSettings = { ...settings };

    const url = `${apiEndpoints.MEDIA_MANAGER_ASSETS.replace(
        '{siteId}',
        siteId
    )}${settingsToQueryString(componentSettings)}`;

    return httpClient({
        type: 'GET',
        url,
        data,
        cache: false,
        error: (xhr, status, err) => {
            console.error(xhr, status, err.toString());
        }
    });
}

export function getSeasons(API, siteId, showId, settings) {
    const componentSettings = { ...settings };
    const DomainUrl = API?.API_BASE_URL || '';
    const url = `${DomainUrl}${apiEndpoints.MEDIA_MANAGER_SEASONS.replace(
        '{siteId}',
        siteId
    )}${seasonSettingsToQueryString(showId, componentSettings)}`;

    return httpClient({
        type: 'GET',
        url,
        cache: false,
        error: (xhr, status, err) => {
            console.error(xhr, status, err.toString());
        }
    });
}

export function getShows(siteId, input) {
    const url = apiEndpoints.MEDIA_MANAGER_SEARCH_SHOWS.replace('{siteId}', siteId);
    const data = {
        query: input,
        ['page-size']: 50
    };

    return httpClient({
        type: 'GET',
        url,
        data,
        cache: false,
        error: (xhr, status, err) => {
            console.error(xhr, status, err.toString());
        }
    });
}
